import { useEffect } from 'react';

import type PusherType from 'pusher-js';

import { env } from '@/env';

export function usePusherHandler(
  channelNames: string[] | string | null | undefined,
  messageName: string,
  handler: () => void,
) {
  useEffect(() => {
    if (!channelNames) {
      return;
    }

    const iterableChannelNames =
      typeof channelNames === 'string' ? [channelNames] : channelNames;
    const pusherProms = iterableChannelNames.map((channelName) => {
      return listenForChange(channelName, messageName, handler);
    });
    return () => {
      if (pusherProms) {
        pusherProms.forEach((prom: Promise<() => void>) => {
          prom.then((cleanup) => cleanup());
        });
      }
    };
  }, [handler, channelNames, messageName]);
}

async function doLoad() {
  const { default: Pusher } = await import('pusher-js');
  return new Pusher(env.NEXT_PUBLIC_PUSHER_KEY, {
    cluster: 'eu',
    forceTLS: true,
    disabledTransports: ['xhr_polling', 'sockjs'],
  });
}

let pusherProm: Promise<PusherType>;
export const loadPusher = () => {
  if (!pusherProm) {
    pusherProm = doLoad();
  }

  return pusherProm;
};

async function listenForChange(
  channelName: string,
  messageName: string,
  handler: () => void,
) {
  const pusher = await loadPusher();
  const channel = pusher.subscribe(channelName);
  const runHandler = () => {
    handler();
  };

  channel.bind(messageName, runHandler);
  return () => {
    channel.unbind(messageName, runHandler);
  };
}
